import { otmsHttp, alarmDataHttp } from '@/utils/http/index';

/**
 * 任务模板分页查询
 * https://yapi.ops.yunlizhi.cn/project/267/interface/api/22597
 */
export function templatePage(data, query) {
  return otmsHttp.post('/app_workspace/task/template/page', data, {
    params: {
      ...query,
    },
  });
}

/**
 * 任务模板详情查询
 * https://yapi.ops.yunlizhi.cn/project/267/interface/api/22595
 */
export function templateDetail(data, query) {
  return otmsHttp.post('/app_workspace/task/template/detail/list', data, {
    params: {
      ...query,
    },
  });
}

/**
 * 创建或更新任务模板
 * https://yapi.ops.yunlizhi.cn/project/267/interface/api/22591
 */
export function templateUpsert(data, query) {
  return otmsHttp.post('/app_workspace/task/template/upsert', data, {
    params: {
      ...query,
    },
  });
}

/**
 * 删除任务模板
 * https://yapi.ops.yunlizhi.cn/project/267/interface/api/22593
 */
export function templateDelete(data, query) {
  return otmsHttp.post('/app_workspace/task/template/delete', data, {
    params: {
      ...query,
    },
  });
}

/**
 * 任务应用分页查询
 * https://yapi.ops.yunlizhi.cn/project/267/interface/api/22575
 */
export function taskProcessPage(data, query) {
  return otmsHttp.post('/app_workspace/task/process/page', data, {
    params: {
      ...query,
    },
  });
}

/**
 * 任务应用详情查询
 * https://yapi.ops.yunlizhi.cn/project/267/interface/api/22573
 */
export function taskProcessDetail(data, query) {
  return otmsHttp.post('/app_workspace/task/process/detail/list', data, {
    params: {
      ...query,
    },
  });
}

/**
 * 任务应用详情带版本号查询
 * https://yapi.ops.yunlizhi.cn/project/267/interface/api/31947
 */
export function taskProcessDetailWithVersion(data, query) {
  return otmsHttp.post('/app_workspace/task/process/version/switch', data, {
    params: {
      ...query,
    },
  });
}

/**
 * 任务应用的开启与禁用
 * https://yapi.ops.yunlizhi.cn/project/267/interface/api/31945
 */
export function setTaskStatus(data, query) {
  return otmsHttp.post('/app_workspace/task/process/status/update', data, {
    params: {
      ...query,
    },
  });
}

/**
 * 创建或更新应用
 * https://yapi.ops.yunlizhi.cn/project/267/interface/api/22569
 */
export function taskProcessUpsert(data, query) {
  return otmsHttp.post('/app_workspace/task/process/upsert', data, {
    params: {
      ...query,
    },
  });
}

/**
 * 删除任务应用
 * https://yapi.ops.yunlizhi.cn/project/267/interface/api/22571
 */
export function taskProcessDelete(data, query) {
  return otmsHttp.post('/app_workspace/task/process/delete', data, {
    params: {
      ...query,
    },
  });
}

/**
 * 全局配置项获取
 */
export function configData(data, params) {
  return otmsHttp.post('/bfs_config/admin/config/list', data, { params });
}

/**
 * 查询货主(客户)列表
 */
export function customerList(data, params) {
  return otmsHttp.post('/crm_plus/customer/page', data, { params });
}

/**
 *
 */

export function warnRulePage(data, params) {
  // (20240814) 临时修复200条, 数据量超过200条时或者请求接口的页面卡顿时, 需要重新讨论数据交互方案
  return alarmDataHttp.post('/warnRule/page?size=200', data, { ...params });
}

/**
 * 获取可扩展的标签列表
 * https://yapi.ops.yunlizhi.cn/project/270/interface/api/42548
 */

export function warnRuleExtendPage(data, params) {
  return alarmDataHttp.post('/warnRule/extend/tags', data, { params });
}

/**
 * 保存扩展规则
 * https://yapi.ops.yunlizhi.cn/project/270/interface/api/42539
 */
export function warnRuleExtendSave(data, params) {
  return alarmDataHttp.post('/warnRule/extend/save', data, { params });
}

/**
 * 保存温度预警配置
 * https://yapi.ops.yunlizhi.cn/project/270/interface/api/50519
 */
export function temperatureConfigSave(data, params) {
  return alarmDataHttp.post('/temperatureConfig/save', data, { params });
}
